module.exports = __webpack_public_path__ + "img/layout.cd65d2e1.png";